import { gql } from "@apollo/client";

export const getSystemHolidayQuery = gql`
    query($input: SystemHolidayInput){
    getSystemHoliday(input: $input) {
        holiday
    }
    }
`;